import { AfterContentChecked, Component } from '@angular/core';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormTooltipComponent } from '@shared/components/form-tooltip/form-tooltip.component';

@Component({
  selector: 'app-group-input',
  templateUrl: './group-input.component.html',
  imports: [FormTooltipComponent, FormlyModule],
})
export class GroupInputComponent
  extends FieldType<FormlyFieldConfig & { tooltip: string; label: string; description: string }>
  implements AfterContentChecked
{
  public hidden: boolean;

  public ngAfterContentChecked(): void {
    this.hidden = this.field.fieldGroup.every((field) => {
      return field.hide;
    });
  }
}
